export default {
  config: {
    filters: '',
    source: '',
    advanced: '',
    profilePath: '',
    school: '',
    groups: ''
  },
  loaded: false,
  filterOpen: false,
  originalPageTitle: document.title,
  originalCanonical: '',
  deepLink: false,
  selectedProfile: null,
  isMobile: false,
  selectedView: 'results',
  focusedItem: false,
  liveProfileData: {
    fsprofiles: [
      {
        "name": "",
        "canonical": "",
        "source": "",
        "media-approved": "",
        "familyName": "",
        "givenName": "",
        "honorificSuffix": "",
        "jobTitle": "",
        "image": "",
        "email": "u",
        "telephone": "",
        "url": "",
        "office": "",
        "mapLink": "",
        "curriculumVitae": "",
        "areasOfInterest": [],
        "roles": []
      }
    ]
  },
  filterTypes: {
    "school": {
      name: "College",
      type: 'role',
      status: false,
    },
    "departments": {
      name: "Department",
      type: 'role',
      status: false,
    },
    "teaching-audiences": {
      name: "Teaching Audience",
      type: 'role',
      status: false,
    },
    "teaching-status": {
      name: "Teaching Status",
      type: 'role',
      status: false,
    },
    "office-types": {
      name: "Office Type",
      type: 'role',
      status: false,
    },
    "areas-study": {
      name: "Areas of Study",
      type: 'role',
      status: false,
    },
    "areasOfInterest": {
      name: "Areas of Interest",
      type: 'root',
      status: false,
    }
  },
  groups: {
    simple: [
      {
        name: "Faculty",
        value: "faculty",
        type: "role",
        data: []
      },
      {
        name: "Staff",
        value: "staff",
        type: "role",
        data: []
      }
    ],
    advanced: [
      {
        name: "Active Faculty",
        value: "active",
        type: "teaching-status",
        data: []
      },
      {
        name: "Adjunct Faculty",
        value: "adjunct",
        type: "teaching-status",
        data: []
      },
      {
        name: "Emeritus Faculty",
        value: "emeritus",
        type: "teaching-status",
        data: []
      },
      {
        name: "Staff",
        value: "staff",
        type: "role",
        data: []
      }
    ]
  },
  selectedFilters: {},
  search: "",
  filteredData: [],
  isShowAllSchools: true,
  layout: "grid",
};



// WEBPACK FOOTER //
// ./src/store.js